import { TableCellType } from "components/LazyTable";
import { AttributeMetaValues } from "types/common-types";
import { MetaValueColumnView } from "./components/MetaValueColumnView";
import { LocationTypeColumnView } from "./components/LocationTypeColumnView";
import { StateColumnView } from "./components/StateColumnView";

export type AttributeTypeConfig = {
  codeConstant: string;
  metaValues: AttributeMetaValues[];
  listColumns?: TableCellType[];
};

export const attributeTypeConfigs: AttributeTypeConfig[] = [
  {
    codeConstant: "spotlights",
    metaValues: [AttributeMetaValues.Color],
  },
  {
    codeConstant: "sponsors",
    metaValues: [
      AttributeMetaValues.MediaLibraryItem,
      AttributeMetaValues.Description,
    ],
  },
  {
    codeConstant: "locations",
    metaValues: [
      AttributeMetaValues.LocationTypeId,
      AttributeMetaValues.Company,
      AttributeMetaValues.Address1,
      AttributeMetaValues.Address2,
      AttributeMetaValues.Address3,
      AttributeMetaValues.City,
      AttributeMetaValues.StateId,
      AttributeMetaValues.ZipCode,
      AttributeMetaValues.Phone,
      AttributeMetaValues.Fax,
      AttributeMetaValues.Email,
      AttributeMetaValues.Directions,
    ],
    listColumns: [
      { accessor: "value", align: "left", width: 200, type: "text", label: "Name" },
      { accessor: "company", align: "left", width: 150, type: "node", label: "Company", View: MetaValueColumnView("Company") },
      { accessor: "city", align: "left", width: 100, type: "node", label: "City", View: MetaValueColumnView("City") },
      { accessor: "state", align: "left", width: 120, type: "node", label: "State", View: StateColumnView },
      { accessor: "locationType", align: "left", width: 150, type: "node", label: "Location Type", View: LocationTypeColumnView },
    ],
  },
];
